import { SET_QUIZ_ANALYSIS, SET_ITEM_ANALYSES, SET_STUDENT_ANALYSES, SET_ANALYSIS_FETCH_IN_PROGRESS, SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS, SET_ANALYSIS_GENERATION_IN_PROGRESS, SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS, SET_ANALYSIS_ERROR, SET_STUDENT_ANALYSIS_ERROR, SET_STATUS_POLLING_IN_PROGRESS, SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS } from '@instructure/quiz-common';
export function setQuizAnalysis(quizAnalysis) {
  return {
    type: SET_QUIZ_ANALYSIS,
    payload: quizAnalysis
  };
}
export function setItemAnalyses(itemAnalyses) {
  return {
    type: SET_ITEM_ANALYSES,
    payload: itemAnalyses
  };
}
export function setStudentAnalyses(studentAnalyses) {
  return {
    type: SET_STUDENT_ANALYSES,
    payload: studentAnalyses
  };
}
export function setFetchInProgress(inProgress) {
  return {
    type: SET_ANALYSIS_FETCH_IN_PROGRESS,
    payload: inProgress
  };
}
export function setStudentAnalysisFetchInProgress(inProgress) {
  return {
    type: SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS,
    payload: inProgress
  };
}
export function setStatusPollingInProgress(inProgress) {
  return {
    type: SET_STATUS_POLLING_IN_PROGRESS,
    payload: inProgress
  };
}
export function setStudentAnalysisStatusPollingInProgress(inProgress) {
  return {
    type: SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS,
    payload: inProgress
  };
}
export function setGenerationInProgress(inProgress) {
  return {
    type: SET_ANALYSIS_GENERATION_IN_PROGRESS,
    payload: inProgress
  };
}
export function setStudentAnalysesGenerationInProgress(inProgress) {
  return {
    type: SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS,
    payload: inProgress
  };
}
export function setAnalysisError(error) {
  return {
    type: SET_ANALYSIS_ERROR,
    payload: error
  };
}
export function setStudentAnalysisError(error) {
  return {
    type: SET_STUDENT_ANALYSIS_ERROR,
    payload: error
  };
}